<template>
  <div class="login-page">
    <el-card class="login-card">
      <h2 class="login-title">科技园区管理系统</h2>
      <el-form :model="loginForm" :rules="rules" ref="loginForm" label-width="0">
        <el-form-item prop="username">
          <el-input
            v-model="loginForm.username"
            placeholder="请输入用户名"
            prefix-icon="el-icon-user"
          ></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            v-model="loginForm.password"
            type="password"
            placeholder="请输入密码"
            prefix-icon="el-icon-lock"
            @keyup.enter.native="handleLogin"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            :loading="loading"
            @click="handleLogin"
            class="login-btn"
          >登录</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import api from '../api/config'

export default {
  name: 'Login',
  data() {
    return {
      loginForm: {
        username: '',
        password: ''
      },
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      },
      loading: false
    }
  },
  methods: {
    handleLogin() {
      this.$refs.loginForm.validate(async (valid) => {
        if (!valid) {
          return false
        }
        
        try {
          this.loading = true
          const response = await api.post('/auth/login', this.loginForm)
          
          if (response.success && response.data && response.data.token) {
            // 保存token
            localStorage.setItem('token', response.data.token)
            
            // 解析JWT获取用户信息
            const payload = this.parseJWT(response.data.token)
            localStorage.setItem('username', payload.username || this.loginForm.username)
            localStorage.setItem('userRole', payload.role || 'ENTERPRISE_USER')
            localStorage.setItem('userId', payload.userId || '')
            
            this.$message.success('登录成功')
            
            // 跳转到重定向页面或首页
            const redirect = this.$route.query.redirect || '/'
            this.$router.push(redirect)
          } else {
            this.$message.error('登录响应异常，请联系管理员')
          }
        } catch (error) {
          console.error('登录失败:', error)
          // 错误信息已经在axios拦截器中处理
        } finally {
          this.loading = false
        }
      })
    },
    
    parseJWT(token) {
      try {
        const base64Url = token.split('.')[1]
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
        const jsonPayload = decodeURIComponent(
          atob(base64).split('').map(c => {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
          }).join('')
        )
        return JSON.parse(jsonPayload)
      } catch (e) {
        console.error('JWT解析失败:', e)
        return {}
      }
    }
  }
}
</script>

<style scoped lang="scss">
.login-page {
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.login-card {
  width: 400px;
  padding: 20px;
  
  .login-title {
    text-align: center;
    font-size: 24px;
    margin-bottom: 30px;
    color: #333;
  }
  
  .login-btn {
    width: 100%;
  }
}

@media screen and (max-width: 768px) {
  .login-card {
    width: 90%;
    margin: 0 20px;
  }
}
</style>
